import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class OrderCommand extends AbstractConfDataCommand {
  moveDown?: boolean;
}